export type ReadonlyTenancyEndpoints = {
    readonly SaveTenancy: string;
    readonly GetTenancys: string;
    readonly GetTenancyById: string;
    readonly UpdateTenancy: string;
    readonly DeleteTenancy: string;
    readonly GetBuilding : string;
    readonly GetLevel : string; 
    readonly GetTenancyList : string;
    readonly checkDeleteInactiveTenancy:string;
    readonly GetAllLeveldropdown:string;
    readonly GetAllTenancyBySiteBuildingLevel:string;
    readonly GetAllTenancyBySiteLevel:string;
    readonly GetAllLevelBySite:string;
    readonly getTenancyByBuildingLevelId: string;
  };

  const controller = 'api/tenancy'

  const TenancyEndpoints: ReadonlyTenancyEndpoints = {
    SaveTenancy: `${controller}/AddUpdateTenancy`,
    GetTenancys: `${controller}/GetTenancy`,
    GetTenancyById: `${controller}/GetTenancyById`,
    UpdateTenancy: `${controller}/AddUpdateTenancy`,
    DeleteTenancy: `${controller}/DeleteTenancy`,
    GetBuilding : `api/Building/GetBuildingBySiteId`,
    GetLevel : `api/Level/GetAllLevelBySiteBuilding`,
    //GetLevel : `api/Level/GetAllLevels`,
    GetTenancyList : `api/Level/GetAllTenancyBySiteBuildingLevel`,
    checkDeleteInactiveTenancy: `${controller}/CheckDeleteInactiveTenancy`,
    GetAllLeveldropdown : `api/Level/GetAllLeveldropdown`,  
    GetAllTenancyBySiteBuildingLevel : `api/Level/GetAllTenancyBySiteBuildingLevel`, 
    GetAllTenancyBySiteLevel : `api/Tasks/GetAllTenancyBySiteLevel`,  
    GetAllLevelBySite : `api/Tasks/GetAllLevelBySite`, 
    getTenancyByBuildingLevelId: `${controller}/GetTenancyByBuildingLevelId`,
  };
  
  export { TenancyEndpoints };